import React from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  review: {
    color: 'orange',
    fontSize: 'medium',
  },
  addedToCampaign: {
    color: 'green',
    fontSize: 'medium',
  },
  indicatorContainer: {
    display: 'flex',
  },
}));

const StatusIndicator = ({ status }) => {
  const classes = useStyles();
  let indicatorComponent;
  switch (status) {
    case 'review':
      indicatorComponent = <ErrorIcon className={classes.review} />;
      break;
    case 'addedToCampaign':
      indicatorComponent = <CheckCircleIcon className={classes.addedToCampaign} />;
      break;
    default:
      return null;
  }

  return (
    <div className={classes.indicatorContainer}>
      {indicatorComponent}
    </div>
  );
};

StatusIndicator.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusIndicator;
